export var PaletteModeCode = /*#__PURE__*/ function(PaletteModeCode) {
    PaletteModeCode["light"] = "light";
    PaletteModeCode["dark"] = "dark";
    PaletteModeCode["glass"] = "glass";
    PaletteModeCode["sidebar"] = "sidebar";
    return PaletteModeCode;
}({});
export var MuiModalClosingReasons = /*#__PURE__*/ function(MuiModalClosingReasons) {
    MuiModalClosingReasons["BackdropClick"] = "backdropClick";
    MuiModalClosingReasons["EscapeKeyDown"] = "escapeKeyDown";
    return MuiModalClosingReasons;
}({});
